<script>
	let {
		stars = 5,
		rating = 0.0,
		starWidth = '1rem',
		hideMetaData = false,
		class: className = '',
	} = $props();

	let starLength = { length: Math.floor(stars) };
	let remainder = rating % 1;
	let percentage = remainder * 100;
	let starsText = $state('');
	for (let i = 0; i < starLength.length; i++) {
		starsText += '⭐️';
	}
</script>

{#snippet icon(iconClass)}
	<svg
		viewBox="-5 -5 110 110"
		width="100%"
		height="100%"
		xmlns="http://www.w3.org/2000/svg"
	>
		<polygon
			points="50,5 61,35 95,35 67,57 78,90 50,70 22,90 33,57 5,35 39,35"
			fill="none"
			stroke="currentColor"
			stroke-width="2.5"
			vector-effect="non-scaling-stroke"
		/>

		<polygon
			points="50,5 61,35 95,35 67,57 78,90 50,70 22,90 33,57 5,35 39,35"
			fill="currentColor"
			class={iconClass}
		/>
	</svg>
{/snippet}
<div
	class={[
		'container flex min-h-[1rem] flex-row gap-0.5 text-[var(--heading-text-color)]',
		className,
	]}
	itemprop="reviewRating"
	itemscope
	itemtype="https://schema.org/Rating"
>
	{#if !hideMetaData}
		<meta itemprop="worstRating" content="1" />
		<meta itemprop="bestRating" content={`${stars}`} />
		<p class="sr-only">
			<span itemprop="ratingValue">{rating}</span> <span>Stars</span>
			{starsText}
		</p>
	{/if}

	<!-- eslint-disable-next-line no-unused-vars -->
	{#each starLength as _, i (i)}
		<div class="grid" style={`width: ${starWidth}`}>
			<div class="col-span-full row-span-full">
				{@render icon('bg')}
			</div>
			<div
				class="col-span-full row-span-full"
				style={`clip-path: polygon(0 0, 0 100%,  ${
					i + 1 <= rating ? 100 : i + 1 == Math.ceil(rating) ? percentage : 0
				}% 100%,  ${
					i + 1 <= rating ? 100 : i + 1 == Math.ceil(rating) ? percentage : 0
				}% 0%);`}
			>
				{@render icon()}
			</div>
		</div>
	{/each}
</div>

<style>
	.bg {
		color: var(--bg-color);
	}
</style>
